import { createSelector } from 'reselect';

const SideBarToggle = state => state.sideBarToggle;

export const selectSideBarShow = createSelector(
    [SideBarToggle],
    sidebarToggle => sidebarToggle.sidebarShow
);